<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard/staff' }">Staff</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar staff</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <div class="wrapper wrapper-full-page section content">
      <div class="container">
        <card id="card">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(updateProfile)">
              <Form :user="user" @submit.prevent />
            </form>
          </ValidationObserver>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/components/Cards/Card.vue";
import Form from "@/views/staff/cuenta/Form.vue";

import { StaffApi, RolesApi } from "@/api";

export default {
  name: "EditStaff",

  components: {
    Card,
    Form,
  },

  data: () => ({
    id: 0,
    loading: false,
    user: {
      firstName: null,
      lastNameP: null,
      lastNameM: null,
      email: null,
      password: null,
      rol: null,
      telefono: null,
      persona: null,
      rfc: null,
      roles_id: null,
      corredurias_id: null,
    },
  }),

  created() {
    this.getStaff();
  },

  methods: {
    async getStaff() {
      try {
        this.loading = true;

        const id = this.$route.params.id;
        const { nombre, paterno, materno, email, telefono, persona, rfc, roles_id, corredurias_id } = await StaffApi.detail(id);

        this.id = id;
        this.user.firstName = nombre;
        this.user.lastNameP = paterno;
        this.user.lastNameM = materno;
        this.user.email = email;
        this.user.telefono = telefono;
        this.user.persona = persona;
        this.user.rfc = rfc;
        this.user.corredurias_id = corredurias_id;
        this.roles_id = roles_id;

        const { rol } = await RolesApi.rolPerId(roles_id);
        this.user.rol = rol;
      } catch (error) {
        this.$toast.error("Sucedió un error al cargar la información, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async updateProfile() {
      try {
        this.loading = true;

        const { id } = await RolesApi.rolId(this.user.rol);
        const data = {
          nombre: this.user.firstName,
          paterno: this.user.lastNameP,
          materno: this.user.lastNameM,
          email: this.user.email,
          corredurias_id: this.user.corredurias_id,
          roles_id: id,
          activo: 1,
        };

        await StaffApi.edit(this.id, data);

        this.$toast.success("Staff actualizado", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
#card {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  /* color: #9a9a9a; */
  color: #ea640b;
  font-size: 13px;
}
</style>
